<template>
  <div class="container mx-auto px-4">
    <div class="text-2xl font-bold mb-6">
      Dimensions & caractéristiques
    </div>
    <div class="table-wrapper">
      <table class="sky__product-features-table">
        <tbody>
          <tr class="sky__product-features-line">
            <td class="sky__product-features-table-cell feature-name">
              Référence
            </td>
            <td class="sky__product-features-table-cell">
              {{ product.sku }}
            </td>
          </tr>
          <tr v-for="attribute in featuresAttributes" :key="attribute.name" class="sky__product-features-line">
            <td class="sky__product-features-table-cell feature-name">
              {{ attribute.name }}
            </td>
            <td class="sky__product-features-table-cell overflow-auto text-center">
              <template v-if="typeof attribute.value === 'object' && attribute.value.code && attribute.value.name">
                <div class="flex justify-center">
                  <div
                    style="width: 20px;height:20px;border: 1px solid black;border-radius: 20px;"
                    :style="{
                      background: attribute.value.code,
                      border: attribute.value.code === '#FFFFFF' ? '1px solid black' : ''
                    }"
                    class="mr-2"
                  />
                  {{ attribute.value.name }}
                </div>
              </template>
              <div v-else>
                {{ attribute.value }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    product: {
      required: true,
      type: Object
    }
  },
  computed: {
    featuresAttributes () {
      return this.product.properties.features
    }
  }
}
</script>

<style lang="scss" scoped>
  .sky__product-features-line {
    &:nth-child(odd) {
      @apply bg-sky_grey_darker;
    }
    &:nth-child(odd) {
      @apply bg-sky_grey_darker;
    }
  }

  .sky__product-features-table-cell {
    @apply text-sm w-1/2 py-5 border-r-4 border-white px-4;
    &.feature-name {
      @apply uppercase font-bold;
    }
  }

  .table-wrapper {
    width: 100%;
    overflow: auto;
  }

  .sky__product-features-table {
    @apply w-full text-center;
    max-width: 100%;
  }
</style>
